import eventBus from "@/utils/eventBus";

/** 预览态：按钮「点击绑定」通过 eventBus 驱动视频/轮播/音乐/网页 */
export default {
  created() {
    if (this.isPreview) {
      eventBus.$on("previewMediaAction", this.onPreviewMediaAction);
    }
  },
  beforeDestroy() {
    eventBus.$off("previewMediaAction", this.onPreviewMediaAction);
  },
  methods: {
    onPreviewMediaAction(payload) {
      if (!this.isPreview || !payload || !this.element) {
        return;
      }
      if (String(payload.targetId) !== String(this.element.id)) {
        return;
      }
      if (typeof this.handlePreviewMediaEvent === "function") {
        this.handlePreviewMediaEvent(payload.event);
      }
    },
  },
};
